import { render, staticRenderFns } from "./courseCard.vue?vue&type=template&id=b908d292&scoped=true&"
import script from "./courseCard.vue?vue&type=script&lang=js&"
export * from "./courseCard.vue?vue&type=script&lang=js&"
import style0 from "./courseCard.vue?vue&type=style&index=0&id=b908d292&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b908d292",
  null
  
)

export default component.exports